import Link from 'next/link'
import { useInView } from 'react-intersection-observer'
import styled, { css } from 'styled-components'
import SwiperCore, { EffectFade, Navigation, Pagination } from 'swiper'
import { breakpoint } from '../layout/styles'
import { Container, Content, Item } from '../styles/Banner'
import { Component, FadeInArea } from '../styles/Component'
import Cta from '../styles/Cta'

SwiperCore.use([Navigation, Pagination, EffectFade])

const FullWidthBanner = ({ item }: any) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0 })

  return (
    <Component ref={ref}>
      <BannerItem
        fixedCover={!item.video_mp4 ? item.image.url : ``}
        light={item.text_style === 'Light'}
        left={item.text_alignment === 'Left'}
        overlay={item.overlay}>
        {item.video_mp4 && (
          <video autoPlay muted loop playsInline poster={item.image && item.image.url}>
            {inView && <source src={item.video_mp4.url} type="video/mp4" />}
          </video>
        )}
        <Container left={item.text_alignment === 'Left'} overlay={item.overlay} static={true}>
          <FadeInArea inView={inView} variant="full">
            <Content variant="small" left={item.text_alignment === 'Left'}>
              <h2>{item.title}</h2>
              <p>{item.description}</p>
              {item.cta &&
                item.cta.length > 0 &&
                item.cta.map((cta: any) => (
                  <Link href={cta.href} key={cta.title} passHref>
                    <Cta light={item.text_style === 'Light'}>{cta.title}</Cta>
                  </Link>
                ))}
              {item.cta.href && (
                <Link href={item.cta.href} passHref>
                  <Cta href="" light={item.text_style === 'Light'}>
                    {item.cta.title}
                  </Cta>
                </Link>
              )}
            </Content>
          </FadeInArea>
        </Container>
      </BannerItem>
    </Component>
  )
}

export default FullWidthBanner

export const BannerItem = styled(Item)`
  background-size: 175%;
  background-position: unset;
  @media ${breakpoint.desktop} {
    background-size: cover;
  }
  --text: black;
  --background: white;
  ${(props) =>
    props.light &&
    css`
      --text: white;
      --background: black;
      @media ${breakpoint.desktop} {
        color: var(--text);
      }
      ${Cta} {
        color: white;
        white-space: nowrap;
        @media ${breakpoint.desktop} {
          color: var(--text);
        }
      }
    `}
`
